module.exports = __webpack_public_path__ + "img/feature_buy_zh.bd4c00ab.png";